var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2"},[(_vm.showAccountStatusComponent)?_c('AccountStatusComponent',{attrs:{"mobile":""}}):_vm._e(),(false && _vm.showAccountStatusComponent)?_c('RewardsComponent',{attrs:{"mobile":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }